export const FEATURES = {
  Inventory: 'inventory',
  Customers: 'customers',
  ProductionLines: 'production-lines',
  Siigo: 'siigo',
} as const;

export type FeatureKey = (typeof FEATURES)[keyof typeof FEATURES];
